import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import {
  FiHome,
  FiSun,
  FiMoon,
  FiMenu,
  FiX
} from 'react-icons/fi';

const PlanwiseLayout = ({ children }) => {
  const { darkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className={`min-h-screen ${darkMode ? 'dark' : ''}`}>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-blue-900 dark:to-purple-900">
        
        {/* Top Navigation — matches the main DashboardLayout bar (h-12) */}
        <nav className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-50 shadow-sm">
          <div className="px-4">
            <div className="flex justify-between items-center h-12">

              {/* Left — Logo, wordmark, Planwise badge */}
              <div className="flex items-center gap-3 min-w-0">
                <Link to="/dashboard" className="flex items-center gap-2 hover:opacity-80 transition-opacity flex-shrink-0">
                  <img
                    className="h-8 w-auto"
                    src="/images/lwlogo.png"
                    alt="LeaveWise"
                  />
                  <span className="leavewise-wordmark text-lg text-gray-800 dark:text-gray-100">
                    LeaveWise
                  </span>
                </Link>

                <div className="hidden sm:block w-px h-5 bg-gray-300 dark:bg-gray-600"></div>

                <div className="flex items-center gap-1.5 min-w-0">
                  <span className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                    Planwise
                  </span>
                  <span className="inline-flex items-center px-1.5 py-0 rounded text-[10px] font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
                    Beta
                  </span>
                </div>
              </div>

              {/* Right — Dashboard button + mobile menu */}
              <div className="flex items-center gap-1.5">
                <button
                  onClick={() => navigate('/dashboard')}
                  className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-sm font-medium text-gray-700 dark:text-gray-300"
                >
                  <FiHome className="w-4 h-4" />
                  Dashboard
                </button>

                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="md:hidden p-1.5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
                  aria-label="Toggle menu"
                >
                  {mobileMenuOpen ? <FiX className="w-5 h-5" /> : <FiMenu className="w-5 h-5" />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden border-t border-gray-200/50 dark:border-gray-700/50 bg-white/90 dark:bg-gray-800/90 backdrop-blur-md">
              <div className="p-4 space-y-2">
                <Link
                  to="/dashboard"
                  className="flex items-center gap-2 p-2 rounded-lg hover:bg-white/50 dark:hover:bg-gray-700/50 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <FiHome className="w-4 h-4" />
                  Dashboard
                </Link>
                
                <button
                  onClick={() => {
                    toggleDarkMode();
                    setMobileMenuOpen(false);
                  }}
                  className="flex items-center gap-2 w-full text-left p-2 rounded-lg hover:bg-white/50 dark:hover:bg-gray-700/50 transition-colors"
                >
                  {darkMode ? <FiSun className="w-4 h-4" /> : <FiMoon className="w-4 h-4" />}
                  {darkMode ? 'Light Mode' : 'Dark Mode'}
                </button>
              </div>
            </div>
          )}
        </nav>

        {/* Full-Width Main Content */}
        <main className="w-full">
          {children}
        </main>
      </div>
    </div>
  );
};

export default PlanwiseLayout;
